import { IS_LOCAL_DEV } from 'config/envVariable';
import { getGameTypeModuleName } from 'config/promoGameTypes';
import { filterUndefinedOrNull } from 'utils/filter';
import { getSubdomainIndex } from 'client/utils/queryString';
import { createTagManger } from 'utils/createElement';

export function initTagManager({ promo = {}, partner = {}, sponsor = {} }) {
    const { id: promoId } = promo;
    if (sponsor.reportGA4MeasurementId) {
        const { name: sponsorName, reportGA4MeasurementId } = sponsor;
        gtmAccountInfoInit({
            uniqueName: sponsorName,
            site: window.location.hostname,
            promoId,
            reportGA4MeasurementId
        });
    } else if (partner.reportGA4MeasurementId) {
        const { name: partnerName, reportGA4MeasurementId } = partner;
        gtmAccountInfoInit({
            uniqueName: partnerName,
            site: window.location.hostname,
            promoId,
            reportGA4MeasurementId
        });
    }

    const { openInApp: partnerOpenInApp = 'false' } = partner;
    const {
        gtmId: custom_GTM,
        adwordRemarketingId: custom_Adwords_Remarketing,
        facebookPixelId: custom_FB_Pixel,
        lineTagId: custom_Line_TagId,
        sendPageView = 1,
        customGA4MeasurementId,
        openInApp: sponsorOpenInApp = 'false'
    } = sponsor;
    gtmCustomInit({
        custom_FB_Pixel,
        custom_Adwords_Remarketing,
        custom_Line_TagId,
        send_page_view: sendPageView,
        customGA4MeasurementId,
        openInApp: JSON.parse(sponsorOpenInApp) || JSON.parse(partnerOpenInApp) || false
    });
    const nonce = window?.nonceForCSP || '';
    createTagManger(custom_GTM, nonce);
}

function pushDataLayer() {
    if (IS_LOCAL_DEV) {
        return;
    }
    try {
        window.dataLayer = window.dataLayer || [];
        if (arguments.length > 1) {
            window.dataLayer.push(arguments);
        } else if (arguments[0]) {
            window.dataLayer.push(arguments[0]);
        }
    } catch (error) {
        console.log('Push data layer failed:', error);
    }
}

export function gtmAccountInfoInit({ uniqueName, site, promoId, reportGA4MeasurementId }) {
    pushDataLayer({
        uniqueName,
        site,
        promoId,
        reportGA4MeasurementId
    });
}

export function gtmCustomInit({
    custom_FB_Pixel,
    custom_Adwords_Remarketing,
    custom_Line_TagId,
    send_page_view,
    customGA4MeasurementId,
    openInApp
}) {
    pushDataLayer({
        event: 'render',
        action: 'render_done',
        custom_FB_Pixel,
        custom_Adwords_Remarketing,
        custom_Line_TagId,
        send_page_view,
        customGA4MeasurementId,
        openInApp
    });
}

export function gtmPushPrize({ prizeName, prizeType, loginId, promoId }) {
    pushDataLayer(
        filterUndefinedOrNull({
            event: 'fever_prize',
            prizeName,
            prizeType,
            promoId,
            loginId
        })
    );
}

export function gtmPushUserLogin({ uid, loginType = '', promoId }) {
    pushDataLayer(
        filterUndefinedOrNull({
            event: 'fever_login',
            loginType,
            loginId: uid,
            promoId
        })
    );
}

export function gtmPushSignUpFormSubmit({ loginId, entryUuid, formId, promoId, sponsorId }) {
    pushDataLayer(
        filterUndefinedOrNull({
            event: 'fever_form_submit',
            entryUuid,
            formId,
            promoId,
            sponsorId,
            loginId
        })
    );
}

export function gtmPushUserPromoEnter({ loginId, entryUuid, promoId, sponsorId, gameType }) {
    pushDataLayer(
        filterUndefinedOrNull({
            event: 'fever_engage_complete',
            entryUuid,
            promoId,
            sponsorId,
            gameType: getGameTypeModuleName(gameType),
            loginId
        })
    );
}

export function gtmPushUserVote({ loginId, entryUuid, mediaId, promoId, sponsorId }) {
    pushDataLayer(
        filterUndefinedOrNull({
            event: 'fever_contest_vote',
            entryUuid,
            mediaId, //(投票作品的id)
            promoId,
            sponsorId,
            loginId
        })
    );
}

export function gtmPushUserOpenAppInWebView({ webViewEventName }) {
    pushDataLayer({
        event: 'fever_open_app',
        webViewEventName
    });
}

export function gtmPushPromoPublish({
    promoId,
    promoUuId,
    sponsorId,
    gameType,
    uniqueName,
    site,
    promoStartDate,
    promoEndDate,
    promoTitle
}) {
    pushDataLayer({
        event: 'promoPublish',
        promoId,
        promoUuId,
        sponsorId,
        gameType: getGameTypeModuleName(gameType),
        uniqueName,
        site,
        promoStartDate,
        promoEndDate,
        promoTitle
    });
}

export function gtmPushPagePublish({ pageId, sponsorId, uniqueName, site, pageTitle }) {
    pushDataLayer({
        event: 'pagePublish',
        pageId,
        sponsorId,
        uniqueName,
        site,
        pageTitle
    });
}

export function gtmPushPrizeResponseFormSubmit({ entryUuid, formId, promoId, sponsorId }) {
    pushDataLayer({
        event: 'fever_winnerform_submit',
        entryUuid,
        formId,
        promoId,
        sponsorId
    });
}

// https://developers.facebook.com/docs/marketing-api/conversions-api/parameters/fbp-and-fbc?locale=en_US
// 2. Format ClickID
export function generateFbcByFbclid(fbclid) {
    const version = 'fb';
    const subdomainIndex = getSubdomainIndex(window.location.href);
    const creationTime = Date.now();
    return subdomainIndex ? `${version}.${subdomainIndex}.${creationTime}.${fbclid}` : null;
}
